import type { PayloadAction } from '@reduxjs/toolkit';
import { type LuMiConversationState, initialState } from './types';

const reducers = {
  clearLuMiConversation: (
    state: LuMiConversationState,
    action: PayloadAction<{ serviceRequestId: string }>,
  ) => {
    const { serviceRequestId } = action.payload;
    delete state.transcripts[serviceRequestId];
    delete state.loading[serviceRequestId];
    delete state.errors[serviceRequestId];
  },

  resetLuMiConversation: () => initialState,

  setPendingTranscriptOpen: (state: LuMiConversationState, action: PayloadAction<boolean>) => {
    state.pendingTranscriptOpen = action.payload;
  },
};

export default reducers;
